import React from 'react';
import { InputNumber } from '@appkit4/react-components/input-number';

interface InputSampleNumberProps {
  title: string;
  value: string;
  onChange: (value: string) => void;
}

const InputSampleNumber = ({ title, value, onChange }: InputSampleNumberProps) => {
    const handleChange = (newValue: number | string, formattedValue: string, event: any) => {
        // Call onChange with the string version of newValue if it's a number, otherwise pass an empty string
        onChange(typeof newValue === 'number' ? newValue.toString() : '');
    };

    // Convert value to a number if it is not empty, otherwise pass undefined to prevent defaulting to 0
    const numberValue = value === '' ? undefined : Number(value);

    return (
        <div className='ap-field-demo-wrapper'>
            <InputNumber
              title={title}
              required={false}
              value={numberValue} // Pass undefined for empty strings to avoid rendering '0'
              onChange={handleChange}
            />
        </div>
    );
}

export default InputSampleNumber;
